import { Box, Grid, Typography } from '@mui/material';
import { styled, experimental_sx as sx } from '@mui/system';
import ValidationMessage from 'components/atoms/ValidationMessage';
import useTranslation from 'next-translate/useTranslation';
import ReactCodeInput from 'react-verification-code-input';

interface IConfirmCodeProps {
    onComplete: (value: string) => void;
    loading?: boolean;
}

const StyledCodeInput = styled(ReactCodeInput)(({ theme }) => ({
    [theme.breakpoints.down('xs')]: {
        width: '240px',
        '& input[type=tel]': {
            width: '40px',
            height: '40px',
        },
    },
    [theme.breakpoints.up('md')]: {
        width: 'unset',
        '& input[type=tel]': {
            width: 'unset',
            height: 'unset',
        },
    },
}));

// sx({
//     width: { xs: '240px', md: 'unset' },
//     '& input[type=tel]': {
//         width: { xs: '40px', md: 'unset' },
//         height: { xs: '40px', md: 'unset' },
//     },
// });

const ConfirmCode = ({ onComplete, loading }: IConfirmCodeProps) => {
    const { t } = useTranslation('common');
    return (
        <Grid container alignItems="center" direction="column">
            <Grid item>
                <Box mb={6}>
                    <Typography style={{ textAlign: 'center', fontSize: '23px', fontWeight: 600, color: '#585757' }}>
                        {t('phoneNumberCode')}
                    </Typography>
                </Box>
            </Grid>
            <StyledCodeInput
                type="number"
                fields={6}
                fieldWidth={50}
                fieldHeight={50}
                onComplete={onComplete}
                loading={loading}
            />
            <Box mt={1}>
                <Grid container justifyContent="center">
                    <ValidationMessage type="CODE_CONFIRMATION" />
                </Grid>
            </Box>
        </Grid>
    );
};

export default ConfirmCode;
